import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/app/PageHeader";

export default function Audit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)); }, []);
  return (
    <div>
      <PageHeader eyebrow="Accountability" title="Audit Trail" testId="audit-header">
        Sign-ins, imports, role changes, configuration changes and refused access attempts are recorded here.
      </PageHeader>
      <div className="overflow-x-auto rounded-xl border border-amber-700/15 bg-white p-5">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead><tr className="text-left text-stone-500"><th className="py-2">When</th><th>Who</th><th>Action</th><th>Detail</th><th>Outcome</th></tr></thead>
          <tbody>{logs.map((l) => (
            <tr key={l.log_id} className="border-t border-amber-700/10">
              <td className="py-2 whitespace-nowrap">{new Date(l.at).toLocaleString()}</td><td>{l.email || "system"}</td>
              <td className="font-mono-data text-xs">{l.action}</td><td className="text-stone-600 text-xs">{l.detail}</td>
              <td className={l.outcome === "deny" ? "text-red-700" : "text-[#285E3B]"}>{l.outcome}</td>
            </tr>))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
